// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"11665600","171":"20a5b69d","995":"7ea707bb"}[chunkId] + ".css";
};